import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { PaginationComponent } from '../common/pagination/pagination.component';
import { CabinetService } from '../services/cabinet.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CabinetListModalComponent } from 'src/app/shared/cabinet-list-modal/cabinet-list-modal.component';


@Component({
  selector: 'app-cabinet-detail',
  standalone: true,
  imports: [CommonModule, PaginationComponent, RouterLink, FormsModule],
  templateUrl: './cabinet-detail.component.html',
  styleUrls: ['./cabinet-detail.component.scss', '../../app.component.scss']
})
export class CabinetDetailComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  isExpand = signal(false);
  isDotPopup = signal(false);
  
  public totalPages: number = 10;
  public currentPage: number = 1;

  public cabinetDetails: any = []; 
  public cabinetProducts: any = []; 
  public cabinetProductCounts: any; 
  public currentCabinetId: string = '';

  public isCabinetProducts: boolean = false;
  public isLowStockAlert: boolean = false;
  public lowStockDetails: any;
  
  public accordionId: string = '';

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isCabinets = true;
  public isSearch = false;

  public isFilter = false;
  public isFilterResult = true;

  public selectedStatus = [];
  
  public expirySortValue:string = "";
  public lastUpdatedAtSortValue:string = "";
  public orderBy:string = "asc";

  constructor(public cabinetService: CabinetService, public dialog: MatDialog, public location: Location, public route: ActivatedRoute) {
  }

  ngOnInit(): void {  
    this.route.params.subscribe(routeParams => {
      this.currentCabinetId = routeParams.id;
      this.getCabinetDetails();
      this.getCabinetProductCounts();
      this.getCabinetProducts();
      this.getCabinetLowStockAlert();
    });
    
  }

  openDotPopup(event){
    document.getElementById("dots-popup").classList.toggle("active");
    // $("#dots-popup").toggleClass("active");
    event.stopPropagation()

    this.closePopupOutside("dots-popup");
  }
  getCabinetDetails(){
    this.cabinetService.getCabinetDetails(this.currentCabinetId).subscribe(res => {
      if (res.data) {
        this.cabinetDetails = res.data;
      }
    });
  }

  getCabinetLowStockAlert(){
    this.cabinetService.getCabinetLowStockAlert(this.currentCabinetId).subscribe(res => {
      if (res.data) {
        this.isLowStockAlert = true;
        this.lowStockDetails = res.data;
      }
    }); 
  }
  
  getCabinetProductCounts(){
    this.cabinetService.getCabinetProductCounts(this.currentCabinetId).subscribe(res => {
      if (res.data) {
        this.cabinetProductCounts = res.data;
      }
    });
  }

  getCabinetProducts(page: string = "", search: string = "", status: Array<string> = ['active', 'missing', 'expired'], expiry: string = "", lastUpdatedAt: string = ""){
    this.cabinetService.getCabinetProducts(this.currentCabinetId, page, search, status, expiry, lastUpdatedAt).subscribe(res => {
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalPages = res.data.last_page;
          this.cabinetProducts = res.data.data;
          
          // Initialize expanded state for each product
          this.cabinetProducts.forEach((product: any) => {
            product.expanded = false;
            product.product_stocks = product.product_stocks || [];
          });

          // Set the appropriate flags
          this.isCabinetProducts = true;
          this.isFilterResult = true; // Always show results when there are products
        }else{
          this.totalPages = 0;
          this.cabinetProducts = [];
          this.isCabinetProducts = false;
          this.isFilterResult = false;
        }
      }
    }, error => {
      console.error('Error loading cabinet products:', error);
    });
  }

  onAccordionChange(event: any, id: string){
    event.stopPropagation();
    
    this.cabinetProducts.forEach(element => {
      if (element.id === id) {
        // Toggle expanded state
        element.expanded = !element.expanded;
        
        if (element.expanded) {
          // If expanding and no stock data, fetch it
          if (element.product_stocks.length === 0) {
            this.cabinetService.showCabinetProducts(this.currentCabinetId, id, this.selectedStatus, this.expirySortValue, this.lastUpdatedAtSortValue).subscribe(res => {
              if (res.data) {
                element.product_stocks = res.data;
                // Initialize expanded state for each stock item
                element.product_stocks.forEach((stock: any) => {
                  stock.expanded = false;
                });
              }
            });
          }
        }
      }
    });
  }

  // Method to handle stock item accordion (second level)
  onStockAccordionChange(event: any, productId: string, stockId: string){
    event.stopPropagation();
    
    this.cabinetProducts.forEach(product => {
      if (product.id === productId && product.product_stocks) {
        const stock = product.product_stocks.find((s: any) => s.id === stockId);
        if (stock) {
          stock.expanded = !stock.expanded;
        }
      }
    });
  }

  openDialog(cabinetName : any, type: string): void {
    const dialogRef = this.dialog.open(CabinetListModalComponent, {
      data: {
        name: cabinetName,
        cabinet_id: this.currentCabinetId,
        type: type
      }
    }); 

    dialogRef.afterClosed().subscribe(result => {
      if (type === 'u_name' && result) {
        this.cabinetDetails.u_name = result;
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) {
        this.selectedStatus = [];
        this.expirySortValue = "";
        this.lastUpdatedAtSortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getCabinetProducts("", this.encodedSearchInput);
    }
  }

  expirySort(){
    this.isFilter = true;

    if (this.expirySortValue === "asc") {
      this.expirySortValue = "desc";
    }else{
      this.expirySortValue = this.orderBy;
    }

    this.onFilterChange();

  }

  openStatusPopup(event){
    document.getElementById("status-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("status-popup");
  }

  missingPopover(event){
    let closestTableData = event.target.closest('td');
    let popup = closestTableData.getElementsByClassName("missing-popover");

    popup[0].classList.toggle("active");
    event.stopPropagation()

    document.addEventListener('click', function(event: any) {
      if (
        popup[0].className.includes("active") &&
        !popup[0].contains(event.target)
      ) {
        popup[0].classList.remove("active");
      }
    })
  }

  onStatusFilterChange(event){
    if (event.target.checked) {
      this.selectedStatus.push(event.target.value);
    }else{
      this.selectedStatus = this.selectedStatus.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;
    this.onFilterChange();
    
  }


  lastUpdatedAtSort(){
    this.isFilter = true;

    if (this.lastUpdatedAtSortValue === "asc") {
      this.lastUpdatedAtSortValue = "desc";
    }else{
      this.lastUpdatedAtSortValue = this.orderBy;
    }

    this.onFilterChange();
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.searchInput = "";
      this.expirySortValue = "";
      this.lastUpdatedAtSortValue = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getCabinetProducts("");
    }
  }

  onFilterChange(){
    if (this.currentPage > 1) { 
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getCabinetProducts("", this.encodedSearchInput, this.selectedStatus, this.expirySortValue, this.lastUpdatedAtSortValue);
  }

  getQueryPage($event: number){
    this.currentPage = $event;
    this.getCabinetProducts(`${this.currentPage}`, this.encodedSearchInput, this.selectedStatus, this.expirySortValue, this.lastUpdatedAtSortValue);
  }

  goBack(){
    this.location.back();
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);
    let editPopup = document.getElementsByClassName("cdk-overlay-container");

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target) &&
        !editPopup[0]?.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
}
